import { render } from "./TituloVistasComponent.vue?vue&type=template&id=36415474&scoped=true"
import script from "./TituloVistasComponent.vue?vue&type=script&lang=js"
export * from "./TituloVistasComponent.vue?vue&type=script&lang=js"

import "./TituloVistasComponent.vue?vue&type=style&index=0&id=36415474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36415474"]])

export default __exports__